import { DesignedModal, Button } from '@clickcease/cc-client-components-lib'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { ContactSupport } from './CancelModal/CancelModal.styled'

export const RevokeProductCancelationConfirmation = ({
  isOpen,
  setIsOpen,
  onConfirm,
  loading,
}: {
  isOpen: boolean
  setIsOpen: (val: boolean) => void
  onConfirm: () => void
  loading?: boolean
}) => {
  const { t } = useTranslation('accountSettings')

  const translate = (key: string) =>
    t(`plan_details.revoke_product_cancelation_confirmation.${key}`)

  return (
    <DesignedModal
      isOpen={isOpen}
      title={translate('title')}
      onOpenChange={setIsOpen}
      actions={
        <>
          <Button
            text={translate('cancel_button')}
            variant="ghost"
            onClick={() => setIsOpen(false)}
          />
          <Button text={translate('confirm_button')} loading={loading} onClick={onConfirm} />
        </>
      }
    >
      <ContactSupport>{translate('description')}</ContactSupport>
    </DesignedModal>
  )
}
